// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__qIIye","footer":"ReportModalFilter_footer__1LUzn"};